export const profile_Teacher = "trilhas_teacher";
export const profile_Admin = "trilhas_admin";
export const profile_AdminGlobal = "trilhas_admin_global";
export const profile_Student = "trilhas_student";
export const profile_Responsavel = "trilhas_responsavel";
export const profile_Coordenator = "trilhas_coordenator";
export const profile_Assistance = "trilhas_class_assistance";
